import styles from "./ViewAllTile.module.css";

type ViewAllTileProps = {
  count: number;
  onClick?: () => void;
};

export const ViewAllTile = ({
  count,
  onClick,
}: ViewAllTileProps): JSX.Element => (
  <button type="button" className={styles.tile} onClick={onClick}>
    <span className={styles.glyph} aria-hidden>
      <svg width="22" height="22" viewBox="0 0 22 22" fill="currentColor">
        <rect x="0" y="0" width="9" height="9" rx="2.5" />
        <rect x="13" y="0" width="9" height="9" rx="2.5" />
        <rect x="0" y="13" width="9" height="9" rx="2.5" />
        <rect x="13" y="13" width="9" height="9" rx="2.5" />
      </svg>
    </span>
    <span className={styles.count}>{count.toLocaleString()}</span>
    <span className={styles.label}>integrations and counting</span>
    <span className={styles.cta}>
      Explore the full catalog
      <span className={styles.arrow} aria-hidden>
        →
      </span>
    </span>
  </button>
);
